export const getModificatorBySelectedAnswer = (answer, selectedAnswer) => {
  if (selectedAnswer && answer) {
    return selectedAnswer.answer === answer.answer ? "configurator-question-body__button--selected" : undefined;
  }
}